import LogRocket from 'logrocket'

const ELIGIBLE_ENVS = ['stg', 'prd']

/**
 * Initializes Logrocket integration and tracking
 */
export const initializeLogRocket = () => {
  const env = window.env.invitaeEnv || ''
  const isEligibleForLogRocket = ELIGIBLE_ENVS.includes(env)
  const user = window.PORTAL.user

  if (!user?.id || !isEligibleForLogRocket) {
    console.warn('Skipping Logrocket initialization')
    return
  }

  LogRocket.init(`invitae/ordering-fulfillment-${env}`, {release: window.appBuildInfo.buildVersion})
  LogRocket.identify(user.id, {email: user.email, name: user.full_name})
}

export default initializeLogRocket
